// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__Msrm6","dark":"Sidebar_dark__OC1Ne","section":"Sidebar_section__ugfH4"};